import { useEffect } from 'react';

/**
 * Forces the portal onto the design system's light surface.
 *
 * Owner ruling (2026-09-09): every mDecide app standardizes on light
 * mode for consistency and simplicity, with no user-facing theme
 * control. The DS ships light and dark as two token sets over one set of
 * semantic roles, activated by `class="dark"` on a wrapping element
 * (surfaces/product-dark.css); this hook therefore ensures `.dark` is
 * never present on <html>, so only the light tokens apply. It no longer
 * follows the operating system's `prefers-color-scheme` and no longer
 * honors a `?theme=` override — both were removed as part of the
 * cross-app theming reconciliation (bead miq-rwsv).
 *
 * The DS `dark:` variants and dark token set are intentionally left in
 * the source (inert) so dark mode can be reintroduced later without
 * rebuilding this seam. The class is managed on <html> because DS
 * popovers and menus portal out of the React tree.
 */
export function usePortalTheme(): void {
  useEffect(() => {
    document.documentElement.classList.remove('dark');
  }, []);
}
